import type { IHubspotPort } from '@onboarding/application/ports';
import type { OnboardingHttpClientType } from '@onboarding/infrastructure/api';

/**
 * Concrete implementation of IHubspotPort.
 * Sends the store profile and service type to the HubSpot properties endpoint.
 */
export const createHubspotRepository = (props: { httpClient: OnboardingHttpClientType }): IHubspotPort => {
  const { httpClient } = props;

  const updateHubspotProperties = async (storeProfile: string, serviceType: string): Promise<void> => {
    await httpClient.updateHubspotProperties({ storeProfile, serviceType });
  };

  return { updateHubspotProperties };
};
